import React, { useState } from 'react';
import styles from './Subscribe.module.css';
import { showToast } from '../../../../utils/toast';
import { subscribeEmail } from '../../../../utils/subscribe';

const Subscribe = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await subscribeEmail(email);
      showToast.success('Thank you for subscribing!');
      setEmail(''); 
    } catch (error) {
      showToast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.newsletterSection}>
      <h3 className={styles.newsletterTitle}>Stay Tuned</h3>
      <p className={styles.newsletterText}>Get updates on our progress so you don't miss a thing.</p>
      <form className={styles.newsletterForm} onSubmit={handleSubmit}>
        <input 
          type="email" 
          placeholder="Email" 
          className={styles.emailInput} 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required 
        />
        <button 
          type="submit" 
          className={styles.subscribeButton}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Subscribing...' : 'Get Updates'}
        </button>
      </form>
    </div>
  );
};

export default Subscribe;
